module.exports = __webpack_public_path__ + "img/11@2x.729dd5ae.png";